import { useMutation } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { AxiosError } from 'axios';
import type { PatchUserSettingsParams } from '../constants';

type PatchUserSettingsRequest = PatchUserSettingsParams;

const usePatchUserSettings = () => {
  const { patchUserSettings } = useMetaApiInstance();

  const mutateFn = async (request: PatchUserSettingsRequest) => {
    await patchUserSettings(request);
  };

  return useMutation<void, AxiosError<unknown, any>, PatchUserSettingsRequest>({
    mutationFn: mutateFn,
    mutationKey: [HOST_QUERY_KEY.UPDATE_USER_SETTINGS],
  });
};

export default usePatchUserSettings;

export type { PatchUserSettingsRequest };
